import React, { Component } from 'react';

/* Components */
import ProductOverviewResults from '~/components/product-overview/components/ProductOverviewResults';

/* Context */
import { StaticData } from '~/context/staticData';

export default class ProductOverview extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <StaticData.Provider value={{ customOptions: this?.props?.customOptions }}>
                <ProductOverviewResults
                    isLoading={false}
                    items={this.props.items}
                    stickerTooltips={this.props.stickerTooltips}
                    loadingElements={12}
                    rowClasses={this.props.rowClasses || 'row row--equalized gutters-4'}
                    colClasses={this.props.colClasses || 'col-12 col-md-6 col-xxxl-4'}
                />
            </StaticData.Provider>
        )
    }
}
